<div class="component-container h-full flex flex-col overflow-hidden">
  @if (createRequest) {
    <app-create-edit-change-in-work-request-form />
  } @else {
    <div class="request-details flex flex-col flex-1 min-h-0 overflow-hidden">
      <div class="heading text-type-2 mb-[40px] flex-shrink-0 flex justify-between items-center">
        <span>{{ data?.request_no }}</span>
        @if (data.status === 'draft') {
          <mat-icon (click)="deleteCIWR(data)" svgIcon="trash" />
        }
      </div>
      <mat-tab-group
        #tabGroup
        (selectedTabChange)="onTabChange($event)"
        [selectedIndex]="selectedTabIndex"
        class="contents-tab-group flex-1 min-h-0 overflow-hidden"
        >
        <mat-tab label="Details">
          <app-create-edit-change-in-work-request-form
            [editChangeInWorkRequestForm]="true"
            class="tab-content"
            />
        </mat-tab>
        <mat-tab label="Workflow">
          <app-change-in-work-request-workflow [data]="data" class="tab-content" />
        </mat-tab>
      </mat-tab-group>
    </div>
  }
</div>
